// Detectamos si estamos en local o en el servidor
const isLocal = window.location.hostname === "localhost"
    || window.location.hostname === "127.0.0.1"
    || window.location.hostname.startsWith("192.168.");
// --- CONFIGURACIÓN DE RUTAS ---
console.log(window.location.hostname)
// Si existe REACT_APP_API_URL (p.ej. en .env.local), se usa directamente.
// Si es local, usa el puerto 8000. Si es producción, usa la ruta relativa /api que maneja Nginx.
export const PATH = process.env.REACT_APP_API_URL
    || (isLocal
        ? `http://${window.location.hostname}:8000`
        : `https://${window.location.hostname}/api`);

// Si es local, usa ws. Si es producción, usa wss y deja que Nginx haga el trabajo en el puerto 443.
export const WS_PATH = isLocal
    ? `ws://${window.location.hostname}:8000`
    : `wss://${window.location.hostname}`;